import React, { useState } from "react";
import axios from "axios";
import { setUserSession } from "./service/AuthService";
import config from "./config";

const APIUrl = config.API_BASE_URL + "/login";

const Login = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (username.trim() === "" || password.trim() === "") {
      setErrorMessage("Valid username and password required");
      return;
    }
    
    setErrorMessage(null);
    setLoading(true);

    axios
      .post(
        APIUrl,
        {
          username: username,
          password: password,
        },
        {
          headers: {
            "x-api-key": config.API_KEY,
          },
        }
      )
      .then((response) => {
        setUserSession(response.data.username, response.data.token);
        props.history.push("/trading");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          setErrorMessage("Invalid username or password");
        } else {
          setErrorMessage("Server error. Please try again later");
        }
      });
  };

  return (
    <div style={{
      backgroundColor: '#000000',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#0a0a0a',
        border: '1px solid #222',
        borderRadius: '8px',
        padding: '40px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ 
            color: '#e0e0e0', 
            fontSize: '24px',
            fontWeight: '600',
            marginBottom: '8px',
            letterSpacing: '0.5px'
          }}>
            BERBUL TRADING
          </h2>
          <p style={{ 
            color: '#888', 
            fontSize: '14px',
            margin: '0'
          }}>
            Sign in to your account
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Username Field */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#ccc',
              fontSize: '13px',
              fontWeight: '500',
              marginBottom: '8px',
              letterSpacing: '0.3px'
            }}>
              USERNAME
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px 14px',
                backgroundColor: '#1a1a1a',
                border: '1px solid #333',
                borderRadius: '4px',
                color: '#e0e0e0',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#10b981'}
              onBlur={(e) => e.target.style.borderColor = '#333'}
              placeholder="Enter username"
            />
          </div>

          {/* Password Field */}
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              color: '#ccc',
              fontSize: '13px',
              fontWeight: '500',
              marginBottom: '8px',
              letterSpacing: '0.3px'
            }}>
              PASSWORD
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px 14px',
                backgroundColor: '#1a1a1a',
                border: '1px solid #333',
                borderRadius: '4px',
                color: '#e0e0e0',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#10b981'}
              onBlur={(e) => e.target.style.borderColor = '#333'}
              placeholder="Enter password"
            />
          </div>

          {/* Error Message */}
          {errorMessage && (
            <div style={{
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              borderRadius: '4px',
              padding: '12px',
              marginBottom: '20px'
            }}>
              <p style={{
                color: '#ef4444',
                fontSize: '13px',
                margin: '0'
              }}>
                {errorMessage}
              </p>
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              background: loading ? '#555' : 'linear-gradient(135deg, #10b981, #059669)',
              border: 'none',
              borderRadius: '4px',
              color: '#ffffff',
              fontSize: '15px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              letterSpacing: '0.5px',
              opacity: loading ? 0.7 : 1
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            {loading ? 'SIGNING IN...' : 'SIGN IN'}
          </button>
        </form>

        {/* Demo Credentials */}
        <div style={{
          marginTop: '24px',
          paddingTop: '24px',
          borderTop: '1px solid #222',
          textAlign: 'center'
        }}>
          <p style={{
            color: '#666',
            fontSize: '12px',
            marginBottom: '8px'
          }}>
            Demo Account
          </p>
          <p style={{
            color: '#888',
            fontSize: '13px',
            margin: '0',
            fontFamily: 'monospace'
          }}>
            demo / demo123
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;